module.exports = __webpack_public_path__ + "img/image_01.de70ba42.jpg";